import React, { useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import axios from "axios";
import Banner from "../Banner";
import Footer from "../Footer";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { id, token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const trackCode = searchParams.get("track");
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "newPassword") {
      setNewPassword(value);
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/user-reset-password/${token}`,
        {
          password: newPassword,
          formId: id,
        },
        {
          headers: {
            'Cache-Control': 'no-cache',
          },
        }
      );
      if (response.status >= 200 && response.status < 300) {
        const navigatePath = trackCode 
        ? `/login/${id}?track=${trackCode}`
        : `/login/${id}`;

        navigate(navigatePath,{ replace: true });


        // navigate(`/login/${id}`, { replace: true });
        toast.success("Password changed successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else {
        toast.error("Failed to change password. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error changing password:", error);
      toast.error(
        error?.response?.data?.message ||
          "An error occurred while changing password. Please try again later.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        }
      );
    }
  };

  const handleGoBack = () => {
    const navigatePath = trackCode 
          ? `/login/${id}?track=${trackCode}`
          : `/login/${id}`;
          
        navigate(navigatePath);
    // navigate(`/login/${id}`);
  };

  const handleToggleNewPasswordVisibility = () => {
    setShowNewPassword((prevShowNewPassword) => !prevShowNewPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(
      (prevShowConfirmPassword) => !prevShowConfirmPassword
    );
  };

  return (
    <>
      <Banner />

      <Box sx={{ display: "flex", justifyContent: "center", mt: 13 }}>
        <Paper elevation={3} sx={{ maxWidth: 500, p: 3 }}>
          <Typography variant="h5" align="center" color="primary" gutterBottom>
            Reset Password
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="New Password"
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  value={newPassword}
                  size="small"
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleToggleNewPasswordVisibility}
                          edge="end"
                        >
                          {showNewPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={handleChange}
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleToggleConfirmPasswordVisibility}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={3}>
                <Button variant="outlined" onClick={handleGoBack}>
                   Back
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Button type="submit" variant="contained">
                  Reset Password
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
      {/* <Footer/> */}
    </>
  );
};

export default ResetPassword;
